const SET_SUBJECTS = (state, subjects) => {
  state.subjects = subjects
}

const ADD_SUBJECT = (state, subject) => {
  state.subjects.push(subject)
}

const DELETE_SUBJECT = (state, id) => {
  state.subjects = state.subjects.filter(s => s.id !== id)
}

const EDIT_SUBJECT = (state, subject) => {
  state.subjects = state.subjects.map(s => {
    if (s.id === subject.id) {
      return subject
    } else {
      return s
    }
  })
}

const IS_LOADED = state => {
  state.isLoaded = true
}

export default {
  ADD_SUBJECT,
  DELETE_SUBJECT,
  EDIT_SUBJECT,
  SET_SUBJECTS,
  IS_LOADED
}
